import type { NextRouter } from 'next/router';

/**
 * Removes specified query params from the current URL. If no params are provided, all query params are removed.
 */
export const RemoveQueryParams = (router: NextRouter, paramsToDelete?: Record<string, string>) => {
    if (!paramsToDelete) {
        return router.replace({ pathname: router.pathname }, undefined, { shallow: true });
    }

    const newQuery = router.query;
    Object.keys(paramsToDelete).forEach((key) => {
        delete newQuery[key];
    });

    return router.replace({ pathname: router.pathname, query: newQuery }, undefined, {
        shallow: true
    });
};
